import React from 'react';
export function SocialProofBar() {
  const stats = [{
    label: '+800 DOCENTES',
    sublabel: 'TODO EL PAÍS'
  }, {
    label: '12 TOMOS LISTOS',
    sublabel: 'PARA USAR'
  }, {
    label: '4.9/5 ⭐',
    sublabel: 'CALIFICACIÓN'
  }, {
    label: 'FÍSICO QUÍMICA',
    sublabel: 'SEC. ARGENTINA'
  }];
  return <section className="bg-carbon text-white py-6 px-4" data-id="element-234">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-235">
        {stats.map((stat, i) => <div key={i} data-id="element-236">
            <div className="font-bold text-sm md:text-base" data-id="element-237">{stat.label}</div>
            <div className="text-xs md:text-sm text-gray-400" data-id="element-238">
              {stat.sublabel}
            </div>
          </div>)}
      </div>
    </section>;
}